import React from "react";
import { useTranslations } from "next-intl";
import { TourSummary } from "@/types/dto/pdp/pdp-tour-summary";
import { Box, Stack, Typography, Link } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import IsThisTourForMe from "./is-this-tour-for-me";
import EnhanceTourCard from "./enhance-tour-card";

interface EssentialTourProps {
  tourSummaryData?: TourSummary;
  activityLevelShortDescription: string;
  activityLevelPhysicalRequirement: string;
  travelStyleNames: string;
  travelStyleDescriptions: string;
  phoneNumber?: string;
}

const EssentialTour = ({
  tourSummaryData,
  activityLevelShortDescription,
  activityLevelPhysicalRequirement,
  travelStyleNames,
  travelStyleDescriptions,
  phoneNumber
}: EssentialTourProps) => {
  const t = useTranslations("PDP");

  if (!tourSummaryData) {
    return null;
  }

  return (
    <Stack
      data-testid="essential-tour-container"
      sx={{
        width: "100%",
        gap: 3,
        maxWidth: "600px",
        margin: "0 auto"
      }}
    >
      <IsThisTourForMe 
        tourSummaryData={tourSummaryData}
        activityLevelShortDescription={activityLevelShortDescription}
        activityLevelPhysicalRequirement={activityLevelPhysicalRequirement}
        travelStyleNames={travelStyleNames}
        travelStyleDescriptions={travelStyleDescriptions} 
      />

      <EnhanceTourCard tourSummaryData={tourSummaryData} />

      {/* Contact Info Section */}
      {phoneNumber && (
        <Box data-testid="contact-info-section" sx={{ bgcolor: "background.warm_strong", p: 2, borderRadius: "8px", display: "flex", gap: 2, alignItems: "flex-start" }}>
          <InfoOutlinedIcon data-testid="contact-info-icon" sx={{ color: "text.primary" }} />
          <Typography data-testid="contact-info-text" variant="body1">
            {t("Have Questions")} <br />{t("Call us")}
            <Link
              data-testid="phone-number-link"
              sx={{
                fontSize: "1.6rem",
                fontWeight: 700,
                color: "secondary.main",
                textDecoration: "underline !important",
                marginLeft: "5px",
                cursor: "pointer"
              }}
              href={`tel:${phoneNumber}`}
            >
              {phoneNumber}
            </Link>
          </Typography>
        </Box>
      )}

    </Stack>
  );
};

export default EssentialTour;
